import React from "react";
import Icon from "@ant-design/icons";
import type { CustomIconComponentProps } from "@ant-design/icons/lib/components/Icon";

const NoNameChatItemSvg = () => (
  <svg width='1em' height='1em' viewBox='0 0 25 25' fill='none'>
    <path
      d='M20.9922 21.0391V19.0391C20.9922 17.9782 20.5708 16.9608 19.8206 16.2106C19.0705 15.4605 18.0531 15.0391 16.9922 15.0391H8.99219C7.93132 15.0391 6.91391 15.4605 6.16376 16.2106C5.41361 16.9608 4.99219 17.9782 4.99219 19.0391V21.0391'
      stroke='white'
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M12.9922 11.0391C15.2013 11.0391 16.9922 9.2482 16.9922 7.03906C16.9922 4.82992 15.2013 3.03906 12.9922 3.03906C10.783 3.03906 8.99219 4.82992 8.99219 7.03906C8.99219 9.2482 10.783 11.0391 12.9922 11.0391Z'
      stroke='white'
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);

export const NoNameChatItemIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={NoNameChatItemSvg} {...props} />
);
